<template>
  <BaseModal
    :model-value="modelValue"
    :show-close="false"
    max-width="512px"
    @update:model-value="$emit('update:modelValue', $event)"
  >
    <div class="success-modal-content text-center">
      <img alt="success" class="success-icon" :src="iconSrc" />
      <p class="success-message">
        {{ message }}
      </p>
    </div>

    <template #footer>
      <button class="success-btn" @click="handleContinue">
        {{ buttonText }}
      </button>
    </template>
  </BaseModal>
</template>

<script>
import BaseModal from '@/components/base/BaseModal.vue';

export default {
  name: 'SuccessModal',

  components: {
    BaseModal,
  },

  props: {
    modelValue: {
      type: Boolean,
      default: false,
    },
    message: {
      type: String,
      required: true,
    },
    buttonText: {
      type: String,
      default: 'Continue',
    },
    iconSrc: {
      type: String,
      required: true,
    },
  },

  emits: ['update:modelValue', 'continue'],

  methods: {
    handleContinue() {
      this.$emit('continue');
      this.$emit('update:modelValue', false);
    },
  },
};
</script>

<style scoped>
/* Matches the scheduler's cancel-show confirmation, which is the standard layout for
   any successful create / update / delete. Values are reproduced here as scoped styles
   rather than reused from .continue-btn / .checkin-complete / .br-18, which live in
   other components' unscoped <style> blocks and are not reliably loaded on every page.
   Scoped to this component via :deep so FilterModal and ConfirmModal are unaffected. */
:deep(.modal-container) {
  background: #151515;
  border: none;
  border-radius: 18px;
}

:deep(.modal-body) {
  padding: 24px;
}

:deep(.modal-footer) {
  justify-content: center;
  border-top: none;
  padding: 0 24px 32px;
}

.success-modal-content {
  border: 0.5px solid #0b5786;
  border-radius: 15px;
  padding: 24px;
}

.success-icon {
  display: block;
  align-self: center;
  width: 45px;
  height: 45px;
  padding: 12px;
  margin: 20px auto 0;
  background: #ffc627;
  border-radius: 60px;
}

.success-message {
  margin: 1rem 0 38px;
  font-size: 14px;
  font-weight: 700;
  color: #fff;
}

.success-btn {
  width: 136px;
  height: 42px;
  border: none;
  border-radius: 10px;
  background: #ffc627;
  color: #000;
  font-size: 16px;
  font-weight: 700;
  cursor: pointer;
  transition: background-color 0.2s;
}

.success-btn:hover {
  background: #e6b123;
}

@media (min-width: 768px) {
  .success-message {
    font-size: 18px;
  }
}
</style>
